import { Sidebar as SidebarBase } from "@omni/components/components/Navigation/Sidebar/sidebar";
import { SidebarProps } from "@omni/types/components/props/sidebar.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";

import { SidebarComponent } from "@/components/Navigation/Sidebar/sidebar.component";

export const Sidebar = ({
    accountLinks,
    profilelink,
    innerHTML
}: SidebarProps<BaseStore.Etna>) => {
    return (
        <SidebarBase
            accountLinks={accountLinks}
            profilelink={profilelink}
            innerHTML={innerHTML}
        >
            <SidebarComponent />
        </SidebarBase>
    );
};
